import React, { ReactNode } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { Text } from "../Ui/Text";
import { IVenueInfo } from "../../interface/IShareInfo";

const useStyles = makeStyles(({ palette, breakpoints }) => {
  return createStyles({
    root: {
      background: palette.primary.main,
      padding: 20,
      borderRadius: 5,
      marginBottom: 10,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0 12px 44px 0 rgba(0, 0, 0, 0.5)",
      [breakpoints.down("sm")]: {
        padding: 15
      }
    },

    eventName: {
      color: palette.primary.contrastText,
      fontWeight: 600,
      marginBottom: 4,
      lineHeight: 1.04,
      textAlign: "center",
      [breakpoints.down("sm")]: {
        fontSize: "2.5rem"
      }
    },
    descriptionText: {
      textAlign: "center",
      color: palette.primary.contrastText,
      fontWeight: 400
    },

    whenText: {
      color: palette.primary.contrastText,
      marginTop: "1.8rem",
      marginBottom: 3,
      fontWeight: "bold"
    },
    venueName: {
      color: palette.primary.contrastText,
      textAlign: "center",
      fontSize: "1rem",
      fontWeight: 400,
      marginBottom: "2rem"
    },

    divider: {
      width: "100%",
      height: 1,
      backgroundColor: "rgba(255,255,255,0.5)"
    }
  });
});

interface IProps {
  venueInfo: IVenueInfo | undefined;
  loading: boolean;
  children: ReactNode;
}

export const TicketInfoPanelV2 = ({
  venueInfo = {
    eventName: "",
    eventDescription: "",
    venueName: "",
    state: "",
    when: "",
    productId: ""
  },
  loading,
  children
}: IProps) => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <Text variant="h2" className={classes.eventName}>
        {venueInfo.eventName}
      </Text>
      <Text variant="h2" className={classes.eventName}>
        {/*description is wrong field for subtitle {venueInfo.eventDescription} */}
      </Text>
      <Text variant="h4" className={classes.whenText}>
        {venueInfo.when}
      </Text>
      <Text variant="h4" className={classes.venueName}>
        {venueInfo.venueName && venueInfo.state
          ? `${venueInfo.venueName}, ${venueInfo.state}`
          : ""}
      </Text>
      <input type="hidden" name="productId" value={venueInfo.productId} />

      <div className={classes.divider} />
      {children}
    </div>
  );
};
